var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import en from "vee-validate/dist/locale/en.json";
import { getUrl, Langs, urls } from "./urls";
var EN = Langs.en;
export var en_mad = {
    banner: "Due to an ongoing reorganization within our institution, we are temporarily unable to process your research requests or make our collections available (with the exception of currently active partnerships).<br><br>We appreciate your understanding and will keep you informed as soon as our services are available again.",
    // "<br>Thank you for your understanding.",
    generic: {
        country: 'Country',
        siteInstitutionel: 'Institutional website',
        title: "Request management",
        titleTicket: 'My requests',
        makeTicket: 'Make a request',
        goToForms: 'Standard view',
        goToFormList: 'Request forms',
        myProfile: 'My profile',
        modifyProfile: 'Edit profile',
        homepage: 'Home',
        noResult: 'No result',
        visibility: 'Visibility',
        removeFilter: 'Remove filter',
        show: 'Show',
        elements: 'elements',
        informationLine1: 'Display element',
        informationLine2: 'to',
        informationLine3: 'on',
        informationLine4: 'elements',
        informationLine5: '(filtered from',
        informationLine6: 'elements in total)',
        tableTitle: 'Title',
        tableCategory: 'Type',
        tableGroup: 'Group',
        tableStatus: 'Status',
        tableAction: 'See request',
        showTicket: 'Request',
        showTicketLabel1: 'Title : ',
        showTicketLabel2: 'Type : ',
        showClose: 'The request is closed.',
        showNotBelong: 'You have no rights on this request',
        messageBy: 'By',
        messageTo: 'to',
        editorSend: 'Send reply',
        editorSendPrivate: 'Internal message',
        editorSendFiles: 'Send selected files',
        createTitle: 'Make a request',
        notifications: 'notification | notifications',
        inscription: 'Register',
        connexion: 'Log in',
        connexionAdmin: 'CS Login',
        username: 'User name',
        email: 'Email',
        password: 'Password',
        csUser: 'CS user',
        passwordConfirm: 'Confirm password',
        remember: 'Remember me',
        connect: 'Log In',
        passwordForgot: 'Forgot your password?',
        register: 'Create new account',
        emailResetPassword: 'Reset password',
        emailAddress: 'E-Mail address',
        emailSend: 'Send',
        resetConfirmPassword: 'Confirm password',
        registerUserTitle: 'Create user',
        registerTitle: 'Register',
        editCustomerTitle: 'Edit customer',
        registerCustomerTitle: 'Register customer',
        registerFirstName: 'First name',
        registerLastName: 'Last name',
        phone: 'Phone',
        phonecode: "Telephone code",
        statusFiaf: 'FIAF status',
        fiaf: 'FIAF member',
        deliveryAddress: 'Delivery address',
        billingAddress: 'Billing address',
        sameAddress: 'Same address',
        differentAddress: 'Different billing address',
        city: 'City',
        streetName: 'Street',
        streetNumber: 'No',
        zipCode: 'ZIP code',
        companyName: 'Company name',
        registerSend: 'Confirm',
        verifyMail: 'Verify email address',
        verifyNewLink: 'A new verification link has been sent.',
        verifyText: 'Before continuing, please check your email and click on the verification link. If you have not received the email:',
        verifyClick: 'Click here to request a new one',
        back: 'Back',
        close: 'Close',
        fillFields: 'Please fill in the fields',
        infos: 'Informations',
        selectOption: 'Select an option',
        dateTimeFormat: 'fr',
        dateLabels: {
            labelPrevDecade: 'Previous decade',
            labelPrevYear: 'Previous year',
            labelPrevMonth: 'Previous month',
            labelCurrentMonth: 'Current month',
            labelNextMonth: 'Next month',
            labelNextYear: 'Next year',
            labelNextDecade: 'Next decade',
            labelToday: 'Today',
            labelSelected: 'Selected date',
            labelNoDateSelected: 'No date selected',
            labelCalendar: 'Calendar',
            labelNav: 'Navigate the calendar',
            labelHelp: 'Use the arrow keys to navigate the calendar'
        },
        timeLabels: {
            labelHours: 'Hours',
            labelMinutes: 'Minutes',
            labelSeconds: 'Seconds',
            labelIncrement: 'Increment',
            labelDecrement: 'Decrement',
            labelSelected: 'Time selected',
            labelNoTimeSelected: 'No time selected',
            labelCloseButton: 'Close'
        },
        filePicker: {
            label: 'Send file',
            button: 'Send file(s)',
            placeholder: 'No selected files',
            text1: "Use the file picker to send a file in the chat. A Maximum of 10 files can be sent at a time (up to 25 MB). The following file types are accepted: doc, docx, xls, xlsx, pdf, txt, rtf, odt, ods, jpeg, jpg, png, zip",
            sentFileListText: 'File sent:',
            tooBig: "File size of 25 MB has been exceeded",
            specialCharacterWarning: "Please, remove special characters (example: apostrophe (\"Vente d\'images.pdf\" renommé \"Vente d_images.pdf\")) from file name and try again",
        },
        billingDetails: {
            text1: 'Billing information',
            alttext1: 'Contact information',
            text2: 'Company / Institution / Enterprise / Private *',
            text3: 'Street name *',
            text4: 'Street number *',
            text5: 'Postal code *',
            text6: 'City *',
            text7: 'Country *',
            text8: 'Contact person',
            text9: 'First name *',
            text10: 'Last name *',
            text11: 'Telephone code *',
            text12: 'Telephone number *',
            text13: 'E-mail address *',
        },
        shippingDetails: {
            text1: 'Shipping information',
            alttext1: 'Location of the payment',
            text2: 'Company / Institution / Enterprise / Private *',
            text3: 'Street name *',
            text4: 'Street number *',
            text5: 'Postal code *',
            text6: 'City *',
            text7: 'Country *',
            text8: 'Contact person',
            alttext8: 'Contact person - logistics manager',
            text9: 'First name *',
            text10: 'Last name *',
            text11: 'Telephone code *',
            text12: 'Telephone number *',
            text13: 'E-mail address *',
        },
        searchedFilm: {
            text1: 'Desired film',
            text2: "Director's first name",
            text3: "Director's last name",
            text4: 'Original title / English title *',
            text5: 'You will be informed about the possibilities of viewing depending on the material available. If necessary, the screening can be arranged at a later date.',
            text6: 'Year of production',
            text7: 'Number of requested films',
        },
    },
    notification: {
        action: 'Go to request:',
        contributor: "You have been assigned the observer role (french: 'intervenant')",
        responsible: "You have been assigned charge of ticket as responsible role (french: 'responsable')",
        message: 'You have a new message',
    },
    requests: {
        text1: 'What is your project?',
        text2: 'Cinémathèque suisse collects, preserves, studies and promotes Swiss and international film heritage. As a national centre of expertise, the institution makes various resources available to the public, private individuals, researchers and professionals. You will find the available resources and how to access them below.',
        text3: 'Cinémathèque suisse does not answer general questions about film history.',
        menu1: 'Access collections',
        menu2: 'Take out deposited material',
        menu3: 'Organise a screening',
        menu4: 'Discover Cinémathèque suisse',
        menu5: 'Donate or deposit materials'
    },
    requestsAccessCollection: {
        menu1: 'Film collections',
        menu2: 'Library',
        menu3: 'Archives and documentary files',
        menu4: 'Iconographic and museum collections',
        menu5: 'Information on the collections',
    },
    requestsRequestMaterial: {
        menu1: 'Access to deposited materials',
    },
    requestsOrganizeProjection: {
        menu1: 'Screen a film from our collections',
        menu2: 'Obtain promotional materials',
        menu3: 'Rent a Cinémathèque suisse screening room',
    },
    requestsSubmitMaterial: {
        menu1: 'Donations and deposits',
        menu2: 'Submission of films supported by the OFC and/or other regional funds',
    },
    requestsAccessCollection1: {
        text1: 'Cinémathèque suisse collects fictional works, documentaries, advertising and commissioned films, family films and amateur films in its Film collections. The entire filmed newsreel of the <b>Swiss Ciné-Journal</b> is also deposited in the Cinémathèque suisse Film collections, which can authorise its use and provide material. The collection of the Swiss Ciné-Journal can be consulted online free of charge on the Memobase platform. Since 2012, Cinémathèque suisse has been acquiring the exploitation rights for Swiss cinemas for a small part of its collection, listed in the <b>Distributed Films</b>, freely accessible on our institutional website.',
        text2: "The General Catalogue of the <b>Film collections</b> is not accessible to the public, but Cin\u00E9math\u00E8que suisse responds to specific requests for the viewing or possible provision of elements of its collections, in accordance with the <a href=\"".concat(getUrl(urls.docs.d01, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations and tariffs for access to film copies - in French</a>. Requests are considered according to the type of material and its condition. On-site consultation is excluded for commercially available works (DVD, Blu-ray or VOD media)."),
        link1: '<b>Ciné-Journal suisse</b><br><a href="https://memobase.ch/fr/recordSet/bar-001?term=cin%C3%A9-journal&context=record_sets&position=2" target="_blank">memobase.ch</a>',
        link2: '<b>Distribution catalogue</b><br><a href="https://www.cinematheque.ch/distribution" target="_blank">cinematheque.ch/diffusion</a>',
        menu1: {
            title: 'Viewing request',
            text1: 'Cinémathèque suisse is open to researchers, students and depositors for on-site viewing in the consultation room at the archiving centre in Penthaz or remotely, in certain cases, of digitised or native digital elements of its Film collections.',
            text2: '<b>All on-site viewing is by appointment via a viewing request.</b>',
            text3: "It is also possible, under certain conditions, to view photochemical elements of the collection on a table. However, as this operation depends on the condition of the material, the type of material and the availability of a technician to accompany the operations, it is done with a minimum delay of fifteen days. Please refer to the <a href=\"".concat(getUrl(urls.docs.d02, EN), "\" target=\"_blank\">\uD83D\uDDCEon-site consultation rates - in French</a>."),
            text4: 'Where possible, some of the digitised documents will be available online, via a secure link.',
            button1: 'Viewing request',
        },
        menu2: 'Request for search and / or rental of a projection copy',
        menu3: {
            title: 'Sale of excerpt',
            text1: 'Cinémathèque suisse makes available extracts from films. To this end, it offers a service for the sale of excerpts <b>limited to certain films in its collections</b>: digital or digitised films as well as the Swiss Ciné-Journal collection.',
            text2: 'Cinémathèque suisse <b>does not carry out digitisations on request</b>. It works on the digitisation of its collection according to a plan corresponding to an internal policy, respecting a conservation calendar and aiming to reflect the widest possible range of film activity in Switzerland.',
            text3: "The collection of digitised films is not public, except for the Swiss Cin\u00E9-Journal and the films in the broadcasting catalogue. Please specify the work you are looking for and we will let you know if material is available. The provision of excerpt(s) is by quotation. Please refer to the <a href=\"".concat(getUrl(urls.docs.d03, EN), "\" target=\"_blank\">\uD83D\uDDCEDetailed conditions for the provision of extracts and CJS issues - in French</a>."),
            text4: '<b>Please note that for works protected by copyright, the written permission of the copyright holder is required before making extracts available. Applicants are responsible for ensuring that their rights are respected.</b>',
            button1: 'Request for an excerpt',
        },
        menu4: {
            title: 'Licence and video material of the Swiss Ciné-Journal',
            text1: "From 1940 to 1975, the Swiss Ciné-Journal was shown as a pre-programme in all cinemas in Switzerland. The more than 6,000 trilingual (German, French and Italian) film reports produced in this way captured precious moments in Switzerland's political, social and cultural life. As a public information medium in the service of the country's spiritual defence, the Swiss Ciné-Journal has become part of Switzerland's collective audiovisual memory.",
            text2: 'The film elements are kept at Cinémathèque suisse and have been completely digitised. They can be consulted on memobase.ch:',
            text3: 'Cinémathèque suisse can provide extracts or exploitation material via the form below:',
            link1: '<a href="https://memobase.ch/fr/recordSet/bar-001?term=cin%C3%A9-journal&context=record_sets&position=2" target="_blank">memobase.ch</a>',
            link2: "<a href=\"".concat(getUrl(urls.docs.d03, EN), "\" target=\"_blank\">\uD83D\uDDCEDetailed conditions for the provision of extracts and CJS issues - in French</a>"),
            button1: 'Application for CJS licences and materials',
        },
    },
    requestsAccessCollection2: {
        text1: "The Penthaz and Zurich sites each host library collections. Their catalogues of monographs, screenplays and DVDs can be consulted in the Renouvaud – Sciences et Patrimoine network.",
        text2: "Library documents can only be ordered via a <b>Renouvaud or Bibliopass reader account</b>. For those who do not have an account: fill in this <a href=\"https://db-prod-bcul.unil.ch/pre-inscription/sp/post.php\" target=\"_blank\">form</a> for a free registration, which will be validated by the CS. ",
        text3: "Collection of documents - whether for on-site consultation or home loan - requires an appointment. The Library will contact the reader by e-mail once the order has been received.",
        link1: '<b>Renouvaud catalogue</b><br><a href="https://cinematheque.renouvaud.ch" target="_blank">https://cinematheque.renouvaud.ch</a>',
        link2: "<a href=\"".concat(getUrl(urls.docs.d04, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations for the use of the Non-Film Department - in French</a>"),
        link3: '<a href="https://www.cinematheque.ch/infos-pratiques/acces-et-horaires" target="_blank">🗎Opening hours</a>',
    },
    requestsAccessCollection3: {
        text1: 'The Caspar online inventory is your first port of call for access to the archive collections and documentary files of the Non-Film collection.',
        text2: '<b>Caspar does not provide access to digitised archives.</b>  Physical archives can only be consulted on site, depending on where they are kept:',
        text3: 'At the <b>Penthaz Research and Archiving Centre</b>',
        text4: 'At the <b>Zurich Research and Archiving Centre</b>',
        text5: 'The <b>digital archives</b> can also be consulted on site, with a choice of location between Penthaz and Zurich. Please submit a request for consultation below, providing, if possible, the reference number of the holdings / files / documents desired.',
        link1: '<b>Caspar</b><br><a href="https://caspar.cinematheque.ch" target="_blank">caspar.cinematheque.ch</a>',
        link2: "<a href=\"".concat(getUrl(urls.docs.d04, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations for the use of the Non-Film Department - in French</a>"),
        link3: '<a href="https://www.cinematheque.ch/en/practical-information/access-and-opening-hours" target="_blank">🗎Opening hours</a>',
        button1: 'Request for on-site consultation',
    },
    requestsAccessCollection4: {
        text1: 'The iconographic and museum collections of Cinémathèque suisse include photographs, posters, slides, film equipment and "pre-cinema" objects.',
        text2: "<b>Work is underway to develop an online catalogue of the collections and access to digitised and native digital documents.</b> In any case, it is possible to send a search request to the collections. Please refer in advance to our <a href=\"".concat(getUrl(urls.docs.d05, EN), "\" target=\"_blank\">\uD83D\uDDCEPrices - in French</a> and find out about our <a href=\"").concat(getUrl(urls.docs.d06, EN), "\" target=\"_blank\">\uD83D\uDDCEConditions of use of the images made available to you - in French</a>."),
        text3: 'For certain requests (research projects, exhibitions, publications), you will be offered an on-site or remote consultation as well as an exchange with a librarian to specify your needs.',
        text4: '<b>Please note that the search for the rights owner and the payment of rights for the use of still images are the responsibility of the applicants.</b>',
        button1: 'Request for still images',
        button2: 'Request for on-site consultation',
    },
    requestsAccessCollection5: {
        text1: "To access the published databases - according to Cin\u00E9math\u00E8que suisse\"s <a href=\"".concat(getUrl(urls.docs.d09, EN), "\" target=\"_blank\">\uD83D\uDDCECollection Policy - in French</a> - please refer to the search tools at your disposal, presented on the corresponding pages"),
        text2: 'In the context of research projects, exhibition projects or any other <b>specific request</b> for information on the Cinémathèque suisse collections (documentary research not linked to a service of provision), you can submit a request for information on the collections below, without guarantee. Depending on the type of request, an on-site consultation of the film database is possible, by appointment. If possible, please indicate any available references (holdings, call numbers) or an exhaustive filmography.',
        text3: '<b>Cinémathèque suisse reserves the right to refuse to process requests for information on the collections.</b>',
        link1: 'Film Collections',
        link2: 'Cinémathèque suisse Library',
        link3: 'Archive and documentary collections',
        link4: 'Iconographic and museum collections',
        button1: 'Request for information on the collections',
    },
    requestsRequestMaterial1: {
        text1: '<b>Film material</b>',
        text2: 'Depending on the terms of the deposit, depositors are entitled to request the <b>provisional release of screening copies</b> or <b>access to the deposited material</b> by sending a request to Cinémathèque suisse in writing using the forms below.',
        text3: "For Swiss depositors and distributors, the release of screening copies is done with a minimum delay of 2 weeks for shipment in Switzerland. Deadlines for other types of film material releases vary depending on the nature of the request. Please refer to the <a href=\"".concat(getUrl(urls.docs.d07, EN), "\" target=\"_blank\">\uD83D\uDDCERates and conditions of provision</a>."),
        text4: '<b>Non-film materials</b>',
        text5: 'Depositors may obtain access to or request the temporary release of deposited non-film material via the on-site consultation form. Please specify your needs and mention your depositor status in the description of the request.',
        button1: 'Release order for screening',
        button2: 'Access to deposited film material',
        button3: 'Request for on-site consultation',
    },
    requestsOrganizeProjection1: {
        text1: '<b>Distribution catalogue</b>',
        text2: 'holds the Swiss - and in some cases foreign - exploitation rights to nearly 200 films, including heritage films - most of which have been restored - and films by contemporary authors. Accessible to the public, this "distribution" catalogue of films is your first gateway to the Film collections.',
        text3: '<b>Film Collections</b>',
        text4: 'Like all film libraries in the world, our catalogue of film collections is not accessible to the public. Cinémathèque suisse does, however, respond to specific requests for consultation or the possible provision of film copies. This practice - applied by FIAF (International Federation of Film Archives) members - is based on confidentiality clauses with regard to depositors and on legal considerations.',
        text5: "<b>Any request for a film copy should be made using the form below.</b> If the desired title is part of the distribution catalogue, you will be informed and the rights can be paid directly to Cin\u00E9math\u00E8que suisse. Otherwise, you will be asked to provide the prior agreement of the rights holders before any release of material. Please refer to the <a href=\"".concat(getUrl(urls.docs.d01, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations and tariffs for access to film copies - in French</a> or the <a href=\"").concat(getUrl(urls.docs.d08, EN), "\" target=\"_blank\">\uD83D\uDDCERates for films in the circulation catalog - in French</a>."),
        text6: '<b>Cinémathèque suisse does not carry out digitisation or transcoding on request.</b>',
        link1: '<b>Distribution Catalogue</b><br><a href="https://www.cinematheque.ch/distribution" target="_blank">cinematheque.ch/distribution</a>',
        button1: 'Request screening copies',
    },
    requestsOrganizeProjection2: {
        text1: '<b>Distribution Catalogue</b>',
        text2: 'Digital material',
        text3: 'For films for which Cinémathèque suisse holds the rights, the available digital promotional material - posters, images, press kits, DCP or video trailers - is freely available for download from the online catalogue:',
        text4: 'Printed material',
        text5: 'For Swiss cinema owners, B1 posters and A5 flyers of films in the distribution catalogue can be ordered via the screening copies request form or directly via the form below (subject to availability),',
        text6: '<b>Iconographic collections</b>',
        text7: 'To search for promotional material not available in the online dissemination catalogue, please make a request via the still image request form below.',
        link1: '<b>Distribution Catalogue</b><br><a href="https://www.cinematheque.ch/distribution" target="_blank">cinematheque.ch/distribution</a>',
        button1: 'Distribution - request posters and flyers',
        button2: 'Request for still images',
    },
    requestsOrganizeProjection3: {
        text1: '<b>Renting a screening room</b>',
        text2: 'The Cinémathèque suisse has two screening rooms in the Capitole cinema: the large, 736-seat historic room (the Freddy Buache room) and the 140-seat small room (the Lucienne Schnegg room).',
        text3: '<b>Renting a room for private or school screenings</b>',
        text4: 'It will be possible to submit rental applications via our platform from September 2024. Applications will be examined for rentals beginning in January 2025.',
        text5: '<b>Renting a room for a public screening</b>',
        text6: 'The rental of a room for a public screening is subject to the submission of a request application addressed to the Cinémathèque suisse and including a screening. The Cinémathèque suisse reserves the right to refuse any request.',
        button3: 'Partnership application',
    },
    requestsDiscoverCS1: {
        menuTitle: 'Virtual exhibitions',
        text1: '<b>Virtual exhibitions</b>',
        text2: 'In addition to the on-site exhibitions organised in collaboration with museums, festivals and other institutions, Cinémathèque suisse offers thematic online exhibitions bringing together emblematic and often unpublished documents that highlight different artistic movements, genres or Swiss and foreign filmmakers.',
        text3: '<b>Programme coming soon</b>',
    },
    requestsDiscoverCS2: {
        menuTitle: 'Visit the Penthaz Research and Archiving Centre',
        text1: 'Cinémathèque suisse organises tours of its Research and Archiving Centre in Penthaz for groups of 10 people or more. Visits are by reservation and can be adapted to different types of audiences. They last about 2 hours.',
        text2: "<b>School groups and children's groups</b>",
        text3: "The educational visits focus on the playful discovery of Cinémathèque suisse's missions and professions.",
        text4: '<b>Private and/or institutional groups</b>',
        text5: 'Cinémathèque suisse offers a so-called classic tour. Depending on the availability of the staff, it is also possible to focus on specific aspects.',
        text6: '<b>For reasons of planning and limited resources, all requests for visits must be made at least 3 months in advance.</b>',
        button1: 'Booking a visit - Penthaz',
    },
    requestsDiscoverCS3: {
        menuTitle: 'Visit the Zürich Research and Archiving Centre',
        text1: 'The Swiss Film Archive organizes tours of its Research and Archiving Center in Zurich. Visits are by reservation and can be adapted to different types of audiences. They last about 2 hours.',
        text2: 'Depending on the availability of the staff, it is possible to focus a visit of the Research and Archiving Center in Zurich on specific aspects of its collections. Please let us know if you have any special wishes when you book your visit.',
        button1: 'Booking a visit - Zurich',
    },
    requestsDiscoverCS4: {
        menuTitle: 'Attend a programme screening as a group',
        text1: 'The Cinémathèque suisse offers screenings at the Capitole from Tuesday to Sunday.',
        text2: '<b>Access and opening hours Café-Billetterie du Capitole</b>',
        text2subtext1: 'Monday: Closed',
        text2subtext2: 'Tuesday - Saturday: 13:30 - 20:30*',
        text2subtext3: 'Sunday 14:00 - 20:30*',
        text2subtext4: '*In the event of special opening times, the Capitole ticketing opens 30 minutes before the start of the first screening.',
        text3: 'The programme of screenings and the booking service are also available online at:',
        text4: '<b>Reservations for private or school groups</b>',
        text5: 'Groups of 10 or more can attend a screening at preferential rates - excluding special screenings and previews. Groups of primary and secondary II pupils also benefit from a special rate of CHF 5 per pupil and free admission for teachers accompanying the group. You can book your seats and request a group rate by submitting the booking request here below.',
        link1: '<a href="https://live.cinematheque.ch" target="_blank">live.cinematheque.ch</a>',
        button1: 'Private: Group booking',
        button2: 'School: Group booking',
    },
    requestsSubmitMaterial1: {
        text1: 'Your voluntary contributions allow us to continuously expand the Cinémathèque suisse collection.',
        text2: '<b>New additions to the collection</b>',
        text3: 'Each request - except for deposits that are already subject to agreements with Cinémathèque suisse - is subject to prior examination.',
        text4: "Donations are accepted on condition that they correspond to the criteria of the Cin\u00E9math\u00E8que suisse <a href=\"".concat(getUrl(urls.docs.d09, EN), "\" target=\"_blank\">\uD83D\uDDCECollection Policy - in French</a>. Under this policy, it is possible that proposals for donations or deposits may be refused, in part or in full. Please apply for a donation or deposit below and <b>do not send any material until we have validated your application</b>."),
        text5: 'The processing and storage of large batches of material may be subject to specific agreements involving processing fees and storage fees, subject to quotation.',
        text6: 'Cinémathèque suisse reserves the right to make an initial selection by discarding items that are unusable, too damaged and/or present a danger to the collection.',
        text7: "For digital deposits, please refer to the <a href=\"".concat(getUrl(urls.docs.d10, EN), "\" target=\"_blank\">\uD83D\uDDCEDigital Deposit Policy - in French</a>."),
        text8: '<b>Compulsory deposits (OFC deposits or films supported by other regional funds)</b>',
        text9: 'Please refer to the dedicated page:',
        link1: 'Submission of films supported by the OFC and/or other regional funds',
        button1: 'Donate or deposit materials',
    },
    requestsSubmitMaterial2: {
        text1: 'In accordance with <a href="https://www.fedlex.admin.ch/eli/cc/2016/291/fr" target="_blank">Article 63 of the Ordinance of the Département fédéral de l’intérieur (DFI) on the Promotion of Cinema (OECin)</a> of 21 April 2016, the recipient of federal financial support for film production is obliged to send the Cinémathèque suisse (CS) the master files used to produce the final version of the film (masterfile). Works supported by other regional funds (cinéforom, Berner Filmförderung, Zürcher Filmstiftung, etc.) are also subject to this obligation, according to the statutes and agreements in force.',
        text2: "Within the framework of this support, Cinémathèque suisse's mandate is to preserve your production over the long term in its maximum original quality. By depositing your material, you ensure its durability in the future. Cinémathèque suisse also collects the promotional material related to the films it preserves. These objects are handled by the Non-Film Department.",
        text3: '<b>Procedure for the submission of films that have received support from the OFC or another regional fund:</b>',
        text4: "Fill in the <a href=\"".concat(getUrl(urls.docs.d11, EN), "\" target=\"_blank\">\uD83D\uDDCEConfirmation of deposit for archiving - in French</a> (italian version available <a href=\"").concat(getUrl(urls.docs.d11, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEhere</a>)."),
        text5: "Ensure that the material complies with the <a href=\"".concat(getUrl(urls.docs.d12, EN), "\" target=\"_blank\">\uD83D\uDDCETechnical Specifications for the mandatory deposit of digital film elements - in French</a> (Italian version available <a href=\"").concat(getUrl(urls.docs.d12, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEhere</a>)."),
        text6: "Send the material to Cinémathèque suisse, with the sender's address, to :<br><br><b>Cinémathèque suisse<br>Centre de recherche et d’archivage<br>Département Film / Dépôt obligatoire<br>Chemin de La Vaux 1<br>1303 Penthaz</b><br><br><b>If possible, include 6 copies of each available printed promotional item (posters, flyers, promotional photos, postcards).</b>",
        text7: 'Cinémathèque suisse informs you that the deposit complies with the requests and validates it with the FOC and/or the organisations concerned.',
        text8: 'If you agree to send us the digital promotional material for archiving, a member of staff will contact you for its acquisition.',
    },
    formViewingRequest: {
        text1: 'Viewing request',
    },
    formViewingRequest1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Reason for the request',
        text4: 'Description of your request and description of the work sought if the title is not known',
        text5: 'Reason for the request / description of the research work:<br><ul><li>Theme</li><li>Institution</li><li>Planned publication</li><li>...</li></ul>',
    },
    formViewingRequest2: {
        text1: 'Desired film',
        text2: "Director's first name",
        text3: "Director's last name",
        text4: 'Original title / English title *',
        text5: 'You will be informed about the possibilities of viewing depending on the material available. If necessary, the screening can be arranged at a later date.',
        text6: 'Year of production',
        text7: 'Number of requested films',
    },
    formViewingRequest3: {
        text1: 'Desired copy version',
        text2: 'Depending on availability:<br><ul><li>original language with subtitles</li><li>German with subtitles</li><li>Italian with subtitles</li><li>Autre</li></ul>If Other, enter the desired version.<br><br>If possible, we will try to offer you material in the selected version. If this is not possible, you will be informed and we will let you know if other versions are available.',
    },
    formViewingRequest4: {
        text1: 'Comments',
        text2: 'Please enter here any comments or specificities that have not been taken into account in the form.',
    },
    formViewingRequest5: {
        text1: "I have read the <a href=\"".concat(getUrl(urls.docs.d02, EN), "\" target=\"_blank\">\uD83D\uDDCEOn-site consultation rates - in French</a> *"),
        text2: 'Send request',
    },
    formViewingRequest6: {
        text1: 'No paid services will be provided without prior confirmation from you.<br><br>' +
            "For customers outside Switzerland, payments are made in advance, on invoice.",
    },
    formClipRequest: {
        text1: 'Clip request',
    },
    formClipRequest1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details on the request *',
        text4: 'Description of your request',
        text5: 'For the Swiss Ciné-journal, please refer to the <a href="/forms/cine-journal">dedicated form</a>.<br><br>After submitting your request, we will send you a quote for the requested extracts, if available.<br><br>In case of a positive answer and after confirmation from you, the production and delivery of the files will require 4 to 6 weeks of additional time</b>.',
    },
    formClipRequest2: {
        text1: 'Work concerned',
        text2: "Director's first name",
        text3: "Director's last name",
        text4: 'Original title / English title',
        text5: 'Prior to delivery of any film excerpts, the prior authorization of the rightful owner must be provided by the applicant. Consultation of certain restored/digitised elements is possible on <a href="https://memobase.ch/fr/search?filter[institution][0]=Cin%C3%A9math%C3%A8que%20suisse" target="_blank">Memobase</a> and <a href="http://www.archimob.ch/" target="_blank">Archimob</a>.',
    },
    formClipRequest3: {
        text1: 'Territory of use',
        text2: {
            option1: 'Switzerland',
            option2: 'Europe',
            option3: 'World',
        },
        text3: 'Type of use',
        text4: {
            option1: 'Private use',
            option2: 'Research work',
            option3: 'Public screening',
            option4: 'Audiovisual production',
            option5: 'Exhibition',
            option6: 'Other',
        },
        text5: 'Broadcast channel',
        text6: {
            option1: 'Broadcast',
            option2: 'Web',
            option3: 'VOD',
            option4: 'Cinema',
            option5: 'Installation',
            option6: 'Other',
        },
    },
    formClipRequest4: {
        text1: 'Comments',
    },
    formClipRequest5: {
        text1: "I have read the <a href=\"".concat(getUrl(urls.docs.d03, EN), "\" target=\"_blank\">\uD83D\uDDCEConditions for requesting clips - in French</a>"),
        text2: 'Send request',
    },
    formCineJournal: {
        text1: 'Licence and video material of the Swiss Ciné-Journal',
    },
    formCineJournal1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details of the request',
        text4: 'Reason or description of the project to use the images',
        text5: 'After submitting your request, we will send you a quote with the requested services.<br><br>Processing time is a minimum of 4 to 6 weeks.',
    },
    formCineJournal2: {
        text1: 'Relevant Ciné-journal issue',
        text2: 'Main title / Item reference number',
        text3: 'Item title *',
        text4: 'I also need to get material for this Swiss Ciné-Journal',
        text5: 'Date of use *',
        text6: 'If you know the reference of the desired Swiss Ciné-Journal, please enter it (subject number, issue number or issue date).',
    },
    formCineJournal3: {
        text1: 'Territory of use',
        text2: {
            option1: 'Switzerland',
            option2: 'Europe',
            option3: 'World',
        },
        text3: 'Type of use',
        text4: {
            option1: 'Private use',
            option2: 'Research work',
            option3: 'Public screening',
            option4: 'Audiovisual production',
            option5: 'Exhibition',
            option6: 'Other',
        },
        text5: 'Broadcast Channel',
        text6: {
            option1: 'Broadcast',
            option2: 'Web',
            option3: 'VOD',
            option4: 'Cinema',
            option5: 'Installation',
            option6: 'Computer',
        },
    },
    formCineJournal4: {
        text1: 'Comment',
    },
    formCineJournal5: {
        text1: "I have read the <a href=\"".concat(getUrl(urls.docs.d13, EN), "\" target=\"_blank\">\uD83D\uDDCELicence fees and materials for the Swiss Cin\u00E9-Journal - in French</a>"),
        text2: 'Send request',
    },
    formOnSiteConsultation: {
        text1: 'On-site consultation request',
    },
    formOnSiteConsultation1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details of the request',
        text4: 'Description of your request',
        text5: "In Penthaz, two consultation rooms are available to users. The premises are equipped with a copy machine and Wi-Fi.<br><br>One of the consultation rooms can be made available for group work. It is recommended to check availability when making an appointment.<br><br>The Penthaz Research and Archiving Centre has a visitors' cafeteria with a drinks and snacks machine and a microwave oven.",
    },
    formOnSiteConsultation2: {
        text1: 'Category and description of documents required for consultation *',
        text2: {
            option1: 'Archive holdings',
            placeholder1: 'Name, topic or call number',
            option2: 'Documentary files',
            placeholder2: 'Name, topic or call number',
            option3: 'Monographs, periodicals, scripts, Blu-ray, DVD',
            placeholder3: 'Name, topic or call number',
            option4: 'Still images',
            placeholder4: 'Name, topic or call number',
            option5: 'Other',
            placeholder5: 'Specify',
        },
        text3: 'Name, topic or call number',
        text4: 'Specify',
        text5: 'At least one category',
    },
    formOnSiteConsultation3: {
        text1: 'Consulting digital documents',
        text2: {
            option1: 'Penthaz Research and Archiving Centre',
            option2: 'Zurich Research and Archiving Centre',
        },
        text3: 'The digitised documents can be consulted in Penthaz or Zurich. Please specify your preference.<br><br>Physical documents can only be consulted in the place where they are kept.<br><br><b><a href="https://www.cinematheque.ch/en/practical-information/access-and-opening-hours" target="_blank"> Consultation rooms and opening hours</a>',
        text4: 'Desired date *',
        text5: 'Minimum 10 to 15 working days between the submission of an application and the first consultation date',
    },
    formOnSiteConsultation4: {
        text1: 'Comments',
    },
    formOnSiteConsultation5: {
        text1: "I have read the <a href=\"".concat(getUrl(urls.docs.d04, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations for the use of the Non-Film Department - in French</a>:"),
        text2: 'Send request',
    },
    formStillImages: {
        text1: 'Request for still images',
    },
    formStillImages1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details of the request',
        text4: 'Film, person, work, subject, type of documents searched for',
        text5: 'Please be as detailed as possible about the images you are looking for. Ideally, you can provide a filmography or reference to an archive.',
    },
    formStillImages2: {
        text1: 'Scope of use',
        text2: {
            option1: 'Private use',
            option2: 'Research work',
            option3: 'Promotion - Public screening',
            option4: 'Print or digital publication',
            option5: 'Exhibition',
            option6: 'Exhibition catalogue',
            option7: 'Video production',
            option8: 'Books',
            option9: 'Loan',
            option10: 'Other',
        },
        text3: 'The resolution of the digital images to be delivered may be specified at a later date, depending on what is available.<br><br>Option "Other": depending on the format, availability of the document and the number of documents to be processed.',
    },
    formStillImages3: {
        text1: 'Preferred delivery date *',
        text2: 'Minimum lead times are 10 to 15 working days from submission of a request to delivery, without guarantees, and depending on the format, availability of the document and the number of documents to be processed.',
    },
    formStillImages4: {
        text1: 'Comments',
    },
    formStillImages5: {
        text1: "I have read the <a href=\"".concat(getUrl(urls.docs.d06, EN), "\" target=\"_blank\">\uD83D\uDDCEDisclaimer of liability - in French</a> *"),
        text2: "I have read the <a href=\"".concat(getUrl(urls.docs.d05, EN), "\" target=\"_blank\">\uD83D\uDDCERates - in French</a> *"),
        text3: 'Send request',
    },
    formInformationRequest: {
        text1: 'Request for information about the collections',
    },
    formInformationRequest1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details of the request',
        text4: 'Please describe your request and, if possible, provide the following information: title(s), person(s), work(s), theme(s), type of document(s) sought...',
        text5: 'Please provide as much detail as possible and indicate any available references (holdings, ratings) or a comprehensive filmography.<br><br>Your request will be processed as soon as possible.',
    },
    formInformationRequest2: {
        text1: 'Target collection type',
        text2: {
            option1: 'Film collection',
            option2: 'Non-Film collection',
            option3: 'All collections',
        },
        text3: 'Which collection(s) are you applying for?',
    },
    formInformationRequest3: {
        text1: 'Use of informations',
        text2: {
            option1: 'Research project',
            option2: 'Exhibition project',
            option3: 'Other use',
        },
        text3: 'What do you intend to use the information request for?',
    },
    formInformationRequest4: {
        text1: 'Comments',
    },
    formInformationRequest5: {
        text1: 'Send request',
    },
    formReleaseOrder: {
        text1: 'Release order for screening',
    },
    formReleaseOrder1: {
        text1: 'Reason for the request',
        text2: 'Description of the request',
        text3: 'If necessary, provide a brief description of your request.<br><br>The minimum processing time is 10 working days.',
    },
    formReleaseOrder2: {
        text1: 'Fund or payment concerned',
        text2: 'Reference(s) (e.g. Meier Hans 2020)',
        text3: 'Film concerned',
        text4: "Director's first name",
        text5: "Director's last name",
        text6: 'Original title / English title *',
        text7: 'Language version (e.g. E/df)',
        text8: 'CS classification number if known (ex. 1999-0123-0101)',
        text9: 'Projection copy',
        text10: {
            placeholder: 'Select projection copy type',
            option1: '35mm',
            option2: '16mm',
            option3: 'DCP',
        },
        text11: 'Screening dates',
        text12: 'First screening',
        text13: 'Last screening',
    },
    formReleaseOrder3: {
        text1: 'Please fill in the destination details of the copies<br><br>' +
            '<b>For Switzerland:</b><br>' +
            'Copies are shipped at least 10 days before the first screening date, by mail (Poste) with signature.',
        text2: "Billing is done the month following the last screening.<br><br>" +
            "Rates before tax<br>" +
            "· Movement fee: CHF 100.00 per copy<br><br>" +
            "Shipping costs before tax:<br>" +
            "· CHF 50.- per copy<br>" +
            "· An Express shipment will be charged CHF 20.00 per copy",
    },
    formReleaseOrder4: {
        text1: 'Comments',
    },
    formReleaseOrder5: {
        text1: "I have read the <a href=\"".concat(getUrl(urls.docs.d07, EN), "\" target=\"_blank\">\uD83D\uDDCEFees for the provision of services to depositors - in French</a> *"),
        text2: 'Send request',
    },
    formReleaseOrder6: {
        text1: 'Number of film for release order',
        text2: 'Maximum 10 films may be requested for release order.',
    },
    formMaterialAccess: {
        text1: 'Access to materials',
    },
    formMaterialAccess1: {
        text1: 'Reason for the request',
        text2: 'Description of the request',
        text3: 'If necessary, provide a brief description of your request.<br><br>The minimum processing time is 10 working days.',
    },
    formMaterialAccess2: {
        text1: 'Fund or payment concerned',
        text2: 'Reference(s) (e.g. Meier Hans 2020)',
        text3: 'Film concerned',
        text4: "Director's first name",
        text5: "Director's last name",
        text6: 'Original title / English title *',
        text7: 'Language version (e.g. E/df)',
        text8: 'CS number if known (e.g. 1999-0123-0101)',
        text9: 'Type of item(s)',
        text10: {
            option1: 'Projection copy',
            option2: 'Print item',
            option3: 'Archive copy',
            option4: 'Other',
        },
        text11: 'If Other, specify type of item',
        text12: 'The possible release of material can be organised later, depending on the needs.',
    },
    formMaterialAccess3: {
        text1: 'Comments',
    },
    formMaterialAccess4: {
        text1: "I have read the <a href=\"".concat(getUrl(urls.docs.d07, EN), "\" target=\"_blank\">\uD83D\uDDCEFees for the provision of services to depositors - in French</a> *"),
        text2: 'Send request',
    },
    formMaterialAccess5: {
        text1: 'A quotation will be sent to you if necessary.<br><br>' +
            'No paid services will be provided without prior confirmation from you.<br><br>' +
            'For customers outside Switzerland, payments are made in advance, on invoice.',
    },
    formProjectionCopy: {
        text1: 'Request a projection copy',
    },
    formProjectionCopy1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details on requesting copies of the Film collections',
        text4: 'For each film searched, specify:\n- Director\n- original title or English title\n- year of production.',
        text5: 'If necessary, provide a brief description of your project.<br><br><b>For Switzerland:</b><br>The minimum processing time is 10 working days.<br><br><b>For foreign countries:</b><br>The minimum processing time is 40 working days.',
    },
    formProjectionCopy2: {
        text1: 'Film wanted',
        text2: "Director's first name",
        text3: "Director's last name",
        text4: 'Original title / English title *',
        text5: 'Screening dates',
        text6: 'First screening (min. 10 days delay) *',
        text7: 'Last screening *',
        text8: 'Number of screenings per film',
        text9: 'Tentative dates',
        text10: '',
        text11: 'Year of production',
    },
    formProjectionCopy3: {
        text1: 'Language version desired',
        text2: 'Desired projection medium',
        text3: {
            option1: '35 mm projection copy',
            option2: 'DCP - Digital Cinema',
            option3: 'Blu-ray or digital projection file',
        },
        text4: 'For films not in the distribution catalogue, the availability of a projection medium is not guaranteed.<br><br>The 35mm copies will be offered according to technical and visual criteria, without any guarantee as to the quality of the projection.<br><br>Cinémathèque suisse does not carry out digitisation or transcoding on request.',
        text5: {
            label: 'Language version',
            placeholder: 'Select a version',
            option1: 'VO s-t. French',
            option2: 'VO s-t. German',
            option3: 'VO s-t. Italian',
            option4: {
                label: 'Other language version',
                text1: 'Other',
                text2: 'Please specify *',
            }
        }
    },
    formProjectionCopy4: {
        text1: 'Place of screening',
        text2: 'Name of the cinema / venue *',
        text3: 'Country of screening',
        text4: 'Type of audience expected',
        text5: {
            option1: 'Paid admissions',
            option2: 'Free admissions',
            option3: 'Festival',
        },
    },
    formProjectionCopy5: {
        text1: 'Printed promotional materials',
        text2: {
            option1: 'B1 Posters',
            option2: 'A5 Flyers',
        },
        text3: 'Quantity',
        text4: 'For films in the broadcast catalogue, do you need printed promotional material (subject to availability)?<br><br>Please note that the request for printed materials concerns only films in the distribution catalogue:<br><a href="https://www.cinematheque.ch/distribution" target="_blank">www.cinematheque.ch/diffusion</a>.',
    },
    formProjectionCopy6: {
        text1: 'Comments',
    },
    formProjectionCopy7: {
        text1: "I have read <a href=\"".concat(getUrl(urls.docs.d01, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations and tariffs for access to film copies - in French</a> *"),
        text2: "I have read the <a href=\"".concat(getUrl(urls.docs.d08, EN), "\" target=\"_blank\">\uD83D\uDDCERates for films in the circulation catalog - in French</a> *"),
        text3: 'Send request',
    },
    formProjectionCopy8: {
        text1: 'Please fill in the destination details of the copies<br><br>' +
            '<b>For Switzerland:</b><br>' +
            'Copies are shipped at least 10 days before the first screening date, by mail (Poste) with signature.<br><br>' +
            "<b>For foreign countries:</b><br>" +
            "The organization of transport and customs as well as the related costs are at the applicant's expense.",
    },
    formProjectionCopy9: {
        text1: "<b>Pour la Suisse:</b><br>" +
            "∙ La facturation est faite le mois suivant la dernière date de projection.<br><br>" +
            "<b>Pour l'étranger:</b><br>" +
            "∙ Un paiement d'avance sur facture sera exigé avant que la copie ne soit libérée pour le transporteur.<br>" +
            "∙ Les frais de douanes et de transport sont à la charge du demandeur.<br>",
    },
    formProjectionCopy10: {
        text1: '<b>For Switzerland:</b><br>The rights for titles in the distribution catalogue can be paid directly to Cinémathèque suisse.',
        text2: '<b>For foreign countries:</b><br>You will be asked to provide the prior agreement of the rights holders before any material is released.',
    },
    formPromotionalMaterial: {
        text1: 'Distribution - ordering promotional material',
    },
    formPromotionalMaterial1: {
        text1: 'Film',
        text2: "Director's first name",
        text3: "Director's last name",
        text4: 'Original title / English title *',
    },
    formPromotionalMaterial2: {
        text1: 'Printed promotional material',
        text2: {
            option1: 'B1 Posters',
            option2: 'A5 Flyers',
        },
        text3: 'Quantity',
        text4: 'Digital promotional material for films in the broadcast catalogue is freely available at: <a href="https://www.cinematheque.ch/distribution" target="_blank">www.cinematheque.ch/diffusion</a>.',
    },
    formPromotionalMaterial3: {
        text1: 'Desired delivery date *',
        text2: 'Minimum delivery time 10 working days',
    },
    formPromotionalMaterial4: {
        text1: 'Comments',
    },
    formPromotionalMaterial5: {
        text1: 'Send request',
    },
    formPromotionalMaterial6: {
        text1: 'Shipping and material costs are covered by the Cinémathèque Suisse for screenings organized by its intermediary.<br><br>' +
            'For any other use, a fee of CHF 15.00 (incl. VAT) per poster, CHF 0.20 (incl. VAT) per flyer and a delivery fee of CHF 11.00 (incl. VAT) per shipment will be charged.<br><br> +' +
            'Any paid service will be provided only after prior confirmation from you.',
    },
    formRoomRental: {
        text1: 'Room Rental Request',
        conditions: {
            general: "I have read the <a href=\"".concat(getUrl(urls.docs.d14, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations and fees for access to film prints \u2013 in French</a>*"),
            cinematographe: 'I have read the <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Terms and conditions of use</a>',
            capitole: 'I have read the <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Terms and conditions of use</a>',
        },
        submit: 'Send request',
    },
    formRoomRental1: {
        text1: 'Type de rental *',
        text2: {
            option1: 'Private screening',
            option2: 'School screening',
        },
        text3: 'You have chosen to provide your own projection media.<br><br>🠚 You undertake to pay the screening rights directly to the rightful owner and to send us the authorisation at the latest 10 working days before the screening date.<br><br>🠚 You undertake to send the screening material to Cinémathèque suisse no later than 10 days before the screening date - to the following address:<br><br><b>Cinémathèque suisse<br>André Schäublin<br>Chemin de la Vaux 1<br>CH-1303 Penthaz</b><br><br><b>If Cinémathèque suisse does not receive the authorisation or the medium within the specified time, it reserves the right to cancel the rental and to demand a cancellation fee.</b><br><br>In the event of cancellation by the user less than 10 working days before the rental date, a minimum cancellation fee of CHF 200 (or 10% of the rental amount) will be charged.',
    },
    formRoomRental2: {
        text1: 'Desired screening room *',
        text2: {
            option1: 'Cinématographe',
            option2: 'Capitole',
        },
        text3: 'The Capitole cinema is currently unavailable for rental, due to renovation works taking place until the end of 2023.',
    },
    formRoomRental3: {
        text1: 'Desired date *',
        text2: 'Desired time',
        text3: 'Minimum period of 2 months between application and first rental date.<br><br><b>Rental hours</b><br>Subject to change<br><br><b>Cinématographe<br>Casino de Montbenon<br>3 Allée Ernest-Ansermet<br>1003 Lausanne</b><br><br>Monday to Saturday<br>9am - 12pm<br><br>Tuesday and Wednesday<br>12pm - 8pm<br><br>Sunday and public holidays<br>Closed<br><br><b>Capitole</b><br>Unavailable: renovation works until late 2023.',
    },
    formRoomRental4: {
        text1: 'Comments',
    },
    formRoomRental6: {
        text1: 'Expected participants *',
    },
    formRoomRental7: {
        text1: 'No paid services will be provided without prior confirmation from you.<br><br>' +
            "For customers outside Switzerland, payments are made in advance, on invoice.",
    },
    formRoomRentalFilm: {
        text1: 'Rental request with film copy',
        conditions: {
            general: "I have read the <a href=\"".concat(getUrl(urls.docs.d14, EN), "\" target=\"_blank\">\uD83D\uDDCERegulations and fees for access to film prints \u2013 in French</a>*"),
            cinematographe: 'I have read the <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Terms and conditions of use</a>',
            capitole: 'I have read the <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Terms and conditions of use</a>',
        },
        submit: 'Send request',
    },
    formRoomRentalFilm1: {
        text1: 'Desired film',
        text2: "Director's first name",
        text3: "Director's last name",
        text4: 'Original title / English title *',
        text5: 'You have chosen to combine your rental request with a projection copy request from Cinématheque Suisse.<br><br>🠚 You can choose a title from the <a href="https://www.cinematheque.ch/distribution" target="_blank">diffusion catalog</a>, for which Cinémathèque Suisse holds the rights and provides projection copies in digital format.<br><br>🠚 You can also indicate the title(s) you wish to project, outside the diffusion catalog.<ul><li>We will search our film collections (35mm or digital copies).</li><li>We will inform you of the available projection copies.</li><li>You undertake to pay the projection rights directly to the right holder.</li><li>If no copy is available, you will be invited to choose other titles.</li></ul>'
    },
    formRoomRentalFilm2: {
        text1: 'Type of rental *',
        text2: {
            option1: 'Private screening',
            option2: 'School screening',
        },
    },
    formRoomRentalFilm3: {
        text1: 'Desired screening room *',
        text2: {
            option1: 'Cinématographe',
            option2: 'Capitole',
            option3: 'Capitole, Freddy Buach room',
            option4: 'Capitole, Lucienne Schnegg room',
        },
        text3: 'The Capitole cinema is currently unavailable for rental, due to renovation works taking place until late 2023.',
    },
    formRoomRentalFilm4: {
        text1: 'Desired date *',
        text2: 'Desired time',
        text3: 'Minimum period of 2 months between application and first rental date.<br><br><b>Rental times</b><br>Subject to change<br><br><b>Cinématographe<br>Casino de Montbenon<br>3 Allée Ernest-Ansermet<br>1003 Lausanne</b><br><br>Monday to Saturday<br>9am - 12pm<br><br>Tuesday and Wednesday<br>12 - 8pm<br><br>Sunday and public holidays<br>Closed<br><br><b>Capitole</b><br>Unavailable: renovation works until late 2023.',
        text4: 'Minimum period of 2 months between application and first rental date.<br><br><b>Rental times</b><br>Subject to change<br><br><b>Cinéma Capitole<br>Avenue du Théâtre 6<br>1005 Lausanne</b><br><br>Monday to Saturday<br>9am - 12pm<br><br>Tuesday and Wednesday<br>12 - 8pm<br><br>Sunday and public holidays<br>Closed',
    },
    formRoomRentalFilm5: {
        text1: 'Comments',
    },
    formRoomRentalFilm6: {
        text1: 'I have read the <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Terms and conditions of us</a>',
        text2: 'I have read the <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Terms and conditions of us</a>',
        text3: 'Send request',
    },
    formRoomRentalFilm7: {
        text1: 'No paid services will be provided without prior confirmation from you.<br><br>' +
            "For customers outside Switzerland, payments are made in advance, on invoice.",
    },
    formPartnershipRequest: {
        text1: 'Partnership Request',
    },
    formPartnershipRequest1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details of the request *',
        text4: 'General description of your request, desired date(s), theme(s) and/or film(s)',
        text5: 'La Cinémathèque suisse currently collaborates with numerous institutions and festivals throughout the year.<br><br>Your request will be examined in particular according to the nature of the proposed event and the availability of theatres.',
    },
    formPartnershipRequest2: {
        text1: 'Target audience',
        text2: {
            option1: 'General public',
            option2: 'Young audience',
        },
        text3: 'For which audience would your event be aimed?',
        text4: 'Cultural outreach',
        text5: {
            option1: 'Yes',
            option2: 'No',
        },
        text6: 'Are you planning any cultural mediation activities during the event (activities for children, school groups, etc.)',
        text7: 'Description of the activities',
        text8: 'If "Yes", briefly describe the planned activities',
    },
    formPartnershipRequest3: {
        text1: 'Comments',
    },
    formPartnershipRequest4: {
        text1: 'Send request',
    },
    formVisitBooking: {
        text1: 'Visit the Penthaz Archive Centre',
    },
    formVisitBooking1: {
        text1: 'Type of visit *',
        text2: {
            option1: 'Regular visit',
            option2: 'Magical visit (7-11 years)',
        },
        text3: "Select a type of visit to see its description.<br><br>The guided tours are led by a team of Cinémathèque suisse staff members who - in addition to their work - take turns presenting the various departments. For this reason, we organise a maximum of one tour per week and we invite you to send us your request as soon as possible.<br><br>The guided tours are part of Cinémathèque suisse's cultural outreach programme and are free of charge.",
    },
    formVisitBooking2: {
        text1: 'Desired date of visit *',
        text2: 'Desired time',
        text3: 'Minimum period of 3 months between the submission of an application and the desired visit date.<br><br><b>Centre de recherche et d’archivage<br>Chemin de la Vaux 1<br>CH-1303 Penthaz</b><br><br><b>Visiting hours</b><br><br><b>Regular visits</b><br>Monday to Friday<br>9am - 12pm / 2 - 5pm<br><br><b>Magical visits</b><br>Twice a month on Mondays by arrangement.<br><br>As parking spaces are limited, we advise you to use public transport. Cinémathèque suisse is a 15-minute walk from the Cossonay-Penthalaz train station.',
        text4: {
            option1: 'Morning',
            option2: 'Afternoon',
        }
    },
    formVisitBooking3: {
        text1: 'Visitor information *',
        text2: 'Brief description of the group',
    },
    formVisitBooking4: {
        text1: 'Number of people (maximum 30) *',
        text2: 'Number',
        text3: 'Age range',
        text4: {
            option1: '7-11',
            option2: '12-15',
            option3: '15-18',
            option4: 'All ages',
        },
        text5: 'Do you have any specific expectations or wishes during your visit?',
        text6: 'Description',
        text7: 'Specific needs',
        text8: {
            option1: 'Course with regular seating',
            option2: 'Course without stairs',
        },
    },
    formVisitBooking5: {
        text1: 'Comments',
        text2: 'Do you have any comments on your request?',
    },
    formVisitBooking6: {
        text1: 'Send request',
    },
    formFilmScreening: {
        text1: 'Attend a screening - Group',
    },
    formFilmScreening1: {
        text1: 'Number of people (10 minimum) *',
        text2: 'Number',
        text3: 'Company / Enterprise / Private',
        text4: 'Company / Institution name',
        text5: 'Group bookings are only possible outside of special screenings and previews, with a minimum of 10 people.<br><br>Once you have received confirmation of your reservation, you can collect and pay for your tickets directly from the cinema box office during opening hours or at least 10 minutes before the screening. After this time, we cannot guarantee your reservation and your tickets will be put back on sale.',
    },
    formFilmScreening2: {
        text1: 'Date of the requested screening *',
        text2: 'Time of the requested screening *',
        text3: 'The programme of screenings is available at:<br><a href="https://www.cinematheque.ch/" target="_blank">www.cinematheque.ch</a>',
    },
    formFilmScreening3: {
        text1: 'Comments',
        text2: 'Do you have any comments on your request?',
    },
    formFilmScreening4: {
        text1: 'Send request',
    },
    formSchoolFilmScreening: {
        text1: 'Attend a screening - School group',
    },
    formSchoolFilmScreening1: {
        text1: 'School *',
        text2: 'Name of school',
        text3: 'Number of pupils *',
        text4: 'Number',
        text5: 'Number of accompanying persons *',
        text6: 'Number',
        text7: 'Canton *',
        text8: 'Age group',
        text9: {
            option1: '7-11',
            option2: '12-15',
            option3: '15-18',
            option4: '18 and over',
        },
        text10: 'Reservations for school groups are only possible outside special screenings and previews.<br><br>After receiving a booking confirmation, you can collect and pay for your tickets directly at the cinema box office during opening hours or at least 10 minutes before the screening. After this time, we cannot guarantee your reservation and your tickets will be put back on sale.<br><br>In order to speed up the procedure at the box office, please bring a printed list with the names of students and accompanying persons attending the screening.',
    },
    formSchoolFilmScreening2: {
        text1: 'Desired screening date *',
        text2: 'Desired screening time *',
        text3: 'The programme of screenings is available at: <br><a href="https://www.cinematheque.ch/" target="_blank">www.cinematheque.ch</a>',
    },
    formSchoolFilmScreening3: {
        text1: 'Comments',
        text2: 'Do you have any comments on your request?',
    },
    formSchoolFilmScreening4: {
        text1: 'Send request',
    },
    formMaterialDeposit: {
        text1: 'Donate or deposit materials',
        conditions: "The material complies with the <a href=\"".concat(getUrl(urls.docs.d12, EN), "\" target=\"_blank\">\uD83D\uDDCETechnical Specifications for the mandatory deposit of digital film elements \u2013 in French</a> (italian version available <a href=\"").concat(getUrl(urls.docs.d12, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEhere</a>)"),
    },
    formMaterialDeposit1: {
        text1: 'Title of the request *',
        text2: 'Title of your request',
        text3: 'Details of the request',
        text4: 'Reason for proposed deposit',
        text5: "After you have submitted your request, Cin\u00E9math\u00E8que suisse will examine your proposal as soon as possible and contact you.<br><br>Under the <a href=\"".concat(getUrl(urls.docs.d09, EN), "\" target=\"_blank\">\uD83D\uDDCECollection Policy - in French</a> and <a href=\"").concat(getUrl(urls.docs.d10, EN), "\" target=\"_blank\">\uD83D\uDDCETerms and conditions for digital deposits - in French</a> at Cin\u00E9math\u00E8que suisse, proposals for donations or deposits may be refused, in part or in full."),
    },
    formMaterialDeposit2: {
        text1: 'Type of deposit',
        text2: {
            option1: 'Deposit',
            option2: 'Donation',
        },
        text3: 'Can you provide an inventory for the relevant deposit?',
        text4: {
            option1: 'Yes',
            option2: 'No',
        },
        text5: 'The donation implies the transfer of ownership of the documents and objects to Cinémathèque suisse.',
    },
    formMaterialDeposit3: {
        text1: 'Types of objects covered by the deposit',
        text2: {
            option1: 'Films: film, digital files, data carriers, etc',
            option2: 'Iconographic objects: photographs, posters, etc.',
            option3: 'Cinematographic equipment',
            option4: 'Paper archives',
        },
        text3: 'Details',
        text4: 'Types of media, title of works, director, year of production, rights holders, provenance, available documentation, etc.',
        text5: 'Description of the iconographic items',
        text6: 'Description of cinematographic apparatus',
        text7: 'Approximate volume',
        text8: 'Please provide an estimate in cubic metres, weight (kilos), possibly the number of pallets (euro)',
        text9: 'Cinémathèque suisse reserves the right to make an initial selection and not to keep items that are unusable, too damaged and/or dangerous for the collection.<br><br>For films, please specify in detail the type of media, title of the work, director, year of production, rights holders, origin, available documentation, etc.<br><br>For the volume: please provide an estimate in m3 , weight (kilos), possibly the number of pallets (euro).',
    },
    formMaterialDeposit4: {
        text1: 'Comments',
        text2: 'Do you have any comments about your request?',
    },
    formMaterialDeposit5: {
        text1: 'Send request',
    },
    formMaterialDeposit6: {
        text1: "<b>Please do not send any material to the Swiss Cinémathèque until we have validated your request.</b>",
    },
    formVisitBookingZh: {
        text1: "Visit the Zürich Archive Centre",
    },
    formVisitBookingZh1: {
        text1: 'Desired date of visit *',
        text2: 'Desired time',
        text3: {
            option1: 'Morning',
            option2: 'Afternoon',
        },
        text4: 'Minimum period of 1 week between the submission of an application and the desired visit date.<br><br><b>Forschungs- und Archivierungszentrum<br>Neugasse 10<br>CH-8005 Zürich</b><br><br><b>Visiting hours</b><br>Monday to Thursday<br>9:00 - 12:30 / 13:30 - 17:00<br><br>Friday closed',
    },
    formVisitBookingZh2: {
        text1: 'Number of persons *',
        text2: 'Number',
        text3: 'Visitor information *',
        text4: 'Brief description of the group',
    },
    formVisitBookingZh3: {
        text1: 'Do you have any specific expectations or wishes during your visit?',
        text2: 'Description',
    },
    formVisitBookingZh4: {
        text1: 'Remarques',
        text2: 'Do you have any comments about your request?',
    },
    formVisitBookingZh5: {
        text1: 'Send request',
    },
    forms: {
        'projection-copy': 'Request a projection copy',
        'clip-request': 'Clip request',
        'viewing-request': 'Viewing request',
        'release-order': 'Release order for screening',
        'material-access': 'Access to materials',
        'cine-journal': 'Licence and video material of the Swiss Ciné-Journal',
        'on-site-consultation': 'On-site consultation request',
        'still-images': 'Request for still images',
        'promotional-material': 'Distribution - ordering promotional material',
        'partnership-request': 'Partnership Request',
        'room-rental': 'Room Rental Request',
        'room-rental-film': 'Rental request with film copy',
        'film-screening': 'Attend a screening - Group',
        'school-film-screening': 'Attend a screening - School group',
        'visit-booking': 'Visit the Penthaz Archive Centre',
        'visit-booking-zh': 'Visit the Zürich Archive Centre',
        'information-request': 'Request for information about the collections',
        'material-deposit': 'Donate or deposit materials',
    },
    formList: {
        title: 'Request forms',
        callToAction: 'Select the corresponding form for your request:',
        headers: {
            section1: 'Film collections',
            section2: 'Non-film collection',
            section3: 'Cultural outreach and program',
            section4: 'Resources',
        },
        section1: {
            link1: 'Request a projection copy',
            link2: 'Clip request',
            link3: 'Viewing request',
            link4: 'Release order for screening',
            link5: 'Access to materials',
            link6: 'Licence and video material of the Swiss Ciné-Journal',
        },
        section2: {
            link1: 'On-site consultation request',
            link2: 'Request for still images',
            link3: 'Distribution - ordering promotional material',
        },
        section3: {
            link1: 'Attend a screening - Group',
            link2: 'Attend a screening - School group',
            link3: 'Partnership Request',
            link4: 'Room Rental Request',
            link5: 'Rental request with film copy',
            link6: 'Visit the Penthaz Archive Centre',
            link7: 'Visit the Zürich Archive Centre',
        },
        section4: {
            link1: "Request for information about the collections",
            link2: "Donate or deposit materials",
        },
    },
    visits: {
        visit1: {
            img: 'https://www.cinematheque.ch/typo3temp/_processed_/csm_3_2fd94e_1191404542.jpg',
            p1: '<b>The regular visit (all audiences))</b><br>Frequency: twice a month',
            p2: 'Designed for a wide audience, the regular visit offers an overview of the work and missions of Cinémathèque suisse: in addition to a brief screening, the staff will outline the various issues related to conservation and restoration, following a tour of the premises lasting approximately two hours.',
        },
        visit2: {
            img: 'https://www.cinematheque.ch/typo3temp/_processed_/csm_3_e7861e_7c4a4769b5.jpg',
            p1: '<b>The magical visit (7-11 years old)</b><br>Frequency: 1 Monday every other week (TBC)',
            p2: 'This 1 1/2-hour visit offers a playful introduction that will allow children to discover the world of archives and to get an overview of the role of Cinémathèque suisse and the type of work carried out by its collaborators (conservation, restoration, etc.). The programme includes discussion, a short screening and workshops on early cinema and animation.',
        },
    },
    rooms: {
        room1: {
            img: 'https://www.cinematheque.ch/sites/default/files/2022-12/Cin%C3%A9matographe_Salle%20de%20projection_Casino%20de%20Montbenon.jpg',
            p1: '<b>Cinematograph Technical Sheet</b><br>Status as of 1 May 2017',
            p2: 'Seating capacity: 101<br>Dimensions : 13m × 6m',
            p3: '<b>Screen</b><br>Dimensions : 4.65m × 2.13m',
            p4: '<b>Projection equipment</b><br>35mm projector: 2× Cinemeccanica Victoria 16mm projector: 1× Prevost double-band<br>Video projector: 1× Barco DP4K-32B',
            p5: '<b>Playback equipment</b><br>Beta player : 1× SONY Betacam J-30 (SP / SX / Digital / MPEG IMX) (5× Analogue – 5× BNC)<br>Blu-Ray player : 1× OPPO Blu-Ray BDP-103 (USB keys mpeg4 H264 50m bitrate limit)<br>DVCAM+MiniDV player: 1× SONY DVCAM+MiniDV (HDV 1080i / HDMI Prog / DV)<br>(60i-30p-24p-30i-25p)<br>Server: 1× Doremi DCP-2000',
            p6: '<b>Sound and other</b><br>DOLBY CP650 (Dolby 5.1)<br>JPA amplifier (hearing impaired loop) 3 wireless microphones (Sennheiser)<br>2 wired microphones (Sennheiser) 1 table microphone (JTS)',
            p7: '<b>Accessories</b><br>1 piano (Sauter)',
            p8: '<b>Stage inputs</b><br>1 HDMI and VGA image input box 6 XLR inputs<br>1 RJ45 input (internet connection)',
            p9: '<b>Disabled access</b><br>Room access: for 1 person (please inform in advance)<br>Toilet access: yes',
        },
    },
    customerProfileShow: {
        text1: 'My profile',
    },
    customerProfileShow1: {
        text1: 'User name',
        text2: 'Email',
        text3: {
            label: 'FIAF status',
            status1: 'FIAF member',
            status2: 'non-member',
        },
        text4: 'Phone',
        text5: 'Delivery address',
        text6: 'Billing address',
        deliveryAddress: {
            text1: 'Country',
            text2: 'City',
            text3: 'Street',
            text4: 'Company',
        },
        billingAddress: {
            text1: 'Country',
            text2: 'City',
            text3: 'Street',
            text4: 'Company',
        }
    },
    customerProfileShow2: {
        text1: "Change E-mail / password",
    },
    cantons: {
        AG: 'Aargau',
        AI: 'Appenzell Innerrhoden',
        AR: 'Appenzell Ausserrhoden',
        BE: 'Bern',
        BL: 'Basel-Landschaft',
        BS: 'Basel-Stadt',
        FR: 'Fribourg',
        GE: 'Geneva',
        GL: 'Glarus',
        GR: 'Grisons',
        JU: 'Jura',
        LU: 'Lucerne',
        NE: 'Neuchâtel',
        NW: 'Nidwalden',
        OW: 'Obwalden',
        SG: 'St. Gallen',
        SH: 'Schaffhausen',
        SO: 'Solothurn',
        SZ: 'Schwyz',
        TG: 'Thurgau',
        TI: 'Ticino',
        UR: 'Uri',
        VD: 'Vaud',
        VS: 'Valais',
        ZG: 'Zug',
        ZH: 'Zurich',
    },
    countries: {
        AF: 'Afghanistan',
        AL: 'Albania',
        DZ: 'Algeria',
        AS: 'American Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctic',
        AG: 'Antigua and Barbuda',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BA: 'Bosnia-Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brazil',
        IO: 'British Indian Ocean',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        CV: 'Cape Verde',
        KY: 'Cayman Islands',
        CF: 'Central African Republic',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CX: 'Christmas Island',
        CC: 'Cocos Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CG: 'Republic of Congo',
        CD: 'Democratic Republic of Congo',
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        CI: 'Ivory Coast',
        HR: 'Croatia',
        CU: 'Cuba',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DK: 'Denmark',
        DJ: 'Djibouti',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        EC: 'Ecuador',
        EG: 'Egypt',
        SV: 'El Salvador',
        GQ: 'Equatorial Guinea',
        ER: 'Eritrea',
        EE: 'Estonia',
        ET: 'Ethiopia',
        FK: 'Falkland Islands',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finland',
        FR: 'France',
        GF: 'French Guiana',
        PF: 'French Polynesia',
        TF: 'French Southern Territories',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgia',
        DE: 'Germany',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Greece',
        GL: 'Greenland',
        GD: 'Grenada',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard and MacDonald Islands',
        VA: 'Holy See (Vatican)',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungary',
        IS: 'Iceland',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Iran',
        IQ: 'Iraq',
        IE: 'Ireland',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        JO: 'Jordan',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KG: 'Kyrgyzstan',
        LA: 'Laos',
        LV: 'Latvia',
        LB: 'Lebanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao',
        MK: 'North Macedonia',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Marshall Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongolia',
        MS: 'Montserrat',
        MA: 'Morocco',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NL: 'Netherlands',
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk Island',
        MP: 'Northern Mariana Islands',
        NO: 'Norway',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestine',
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippines',
        PN: 'Pitcairn Islands',
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Qatar',
        RE: 'Réunion',
        RO: 'Romania',
        RU: 'Russia',
        RW: 'Rwanda',
        SH: 'Saint Helena',
        KN: 'Saint Kitts and Nevis',
        LC: 'Saint Lucia',
        PM: 'Saint Pierre and Miquelon',
        VC: 'Saint Vincent and the Grenadines',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'São Tomé and Príncipe',
        SA: 'Saudi Arabia',
        SN: 'Senegal',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SK: 'Slovakia',
        SI: 'Slovenia',
        SB: 'Solomon Islands',
        SO: 'Somalia',
        ZA: 'South Africa',
        GS: 'South Georgia and the South Sandwich Islands',
        ES: 'Spain',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard and Jan Mayen Island',
        SZ: 'Kingdom of Eswatini',
        SE: 'Sweden',
        CH: 'Switzerland',
        SY: 'Syria',
        TW: 'Taiwan',
        TJ: 'Tajikistan',
        TZ: 'United Republic of Tanzania',
        TH: 'Thailand',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad and Tobago',
        TN: 'Tunisia',
        TR: 'Turkey',
        TM: 'Turkmenistan',
        TC: 'Turks and Caicos Islands',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        AE: 'United Arab Emirates',
        GB: 'United Kingdom',
        US: 'United States of America',
        UM: 'United States Minor Outlying Islands',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietnam',
        VG: 'British Virgin Islands',
        VI: 'US Virgin Islands',
        WF: 'Wallis and Futuna',
        EH: 'Western Sahara',
        YE: 'Yemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
        AX: 'Åland',
        BQ: 'Bonaire, St Eustatius and Saba',
        CW: 'Curaçao',
        GG: 'Guernsey',
        IM: 'Isle of Man',
        JE: 'Jersey',
        ME: 'Montenegro',
        BL: 'Saint Barthélemy',
        MF: 'Saint-Martin (French part)',
        RS: 'Serbia',
        SX: 'Sint Maarten (Dutch part)',
        SS: 'South Sudan',
        XK: 'Kosovo',
    },
    validation: __assign({ startBeforeEnd: "First screening date must be defined before last screening", initialDateDelay: "Initial delay is not respected", disallowWeekend: "Saturday and sunday cannot be selected", any: "Please select at least one of the categories", checked: "" }, (en.messages)),
};
